import { render, staticRenderFns } from "./PopularArtists.vue?vue&type=template&id=b394de9e&scoped=true&"
import script from "./PopularArtists.vue?vue&type=script&lang=js&"
export * from "./PopularArtists.vue?vue&type=script&lang=js&"
import style0 from "./PopularArtists.vue?vue&type=style&index=0&id=b394de9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b394de9e",
  null
  
)

export default component.exports